function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f7f7f7;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Stand_Edge_2",
  "data-name": "Stand Edge 2",
  className: "cls-1",
  d: "M24.26,49.26c0,.22.51.46,2.56.46H41.5c2,0,2.53-.24,2.55-.46v.25c0,.23-.39.49-2.55.49H26.82c-2.16,0-2.58-.26-2.56-.49Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Stand-2",
  className: "cls-2",
  d: "M41.5,49.76H26.82c-2.93,0-2.66-.48-2.42-.72s1-.88,1.56-1.39a3.53,3.53,0,0,0,1-2c.15-.73.41-4.83.41-4.83H41s.26,4.1.41,4.83a3.41,3.41,0,0,0,1,2c.61.51,1.32,1.16,1.56,1.39S44.43,49.76,41.5,49.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M66.08,0H2.23A2.23,2.23,0,0,0,0,2.23V38.79A2.23,2.23,0,0,0,2.23,41H66.08a2.23,2.23,0,0,0,2.24-2.23V2.23A2.23,2.23,0,0,0,66.08,0ZM34.16,1.08a.32.32,0,0,1,.32.32.33.33,0,0,1-.32.32.32.32,0,0,1-.32-.32A.32.32,0,0,1,34.16,1.08ZM66.08,38.47H2.23V2.55H66.08Z"
}));

var SvgPcLight = function SvgPcLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 68.32,
    height: 50,
    viewBox: "0 0 68.32 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPcLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PcLight.ee2d3ad0.svg";
export { ForwardRef as ReactComponent };